// Flussi CContact REVO Iberia: 19 = dev/uat, 31 = prod
export const REVO_IBERIA_FLUSSO_IDS = ['19', '31'];

export const isFlussoIberia = (idFlusso) => (
  idFlusso !== null && idFlusso !== undefined && REVO_IBERIA_FLUSSO_IDS.includes(String(idFlusso))
);